import * as React from "react"

const DEFAULT_MOBILE_BREAKPOINT = 990

/**
 * Hook para detectar se a viewport está em modo "mobile".
 *
 * - Por padrão usa 990px, mas é possível sobrescrever passando um breakpoint.
 * - Ex: `useIsMobile(1200)` para considerar mobile abaixo de 1200px.
 */
export function useIsMobile(breakpoint: number = DEFAULT_MOBILE_BREAKPOINT) {
  // Inicializa com o valor correto se estiver no cliente
  const [isMobile, setIsMobile] = React.useState<boolean>(() => {
    if (typeof window !== "undefined") {
      return window.innerWidth < breakpoint
    }
    return false
  })

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`)
    const onChange = () => {
      setIsMobile(window.innerWidth < breakpoint)
    }
    mql.addEventListener("change", onChange)
    // Atualiza imediatamente para garantir que está correto
    setIsMobile(window.innerWidth < breakpoint)
    return () => mql.removeEventListener("change", onChange)
  }, [breakpoint])

  return isMobile
}
